
import Beast from "./Beast.png";
import Dragon from "./Dragon.png";
import Elemental from "./Elemental.png";
import Giant from "./Giant.png";
import Mage from "./Mage.png";
import Map from "./Map.png";
import Plant from "./Plant.png";
import Shield from "./Shield.png";
import Undead from "./Undead.png";

import Aberration from "./Aberration.png";
import Book from "./Book.png";
import Bridge from "./Bridge.png";
import Campfire from "./Campfire.png";
import Cavern from "./Cavern.png";
import Celestial from "./Celestial.png";
import Construct from "./Construct.png";
import Corpse from "./Corpse.png";
import Crossroads from "./Crossroads.png";
import Door from "./Door.png";
import Expert from "./Expert.png";
import Fey from "./Fey.png";
import Fiend from "./Fiend.png";
import Humanoid from "./Humanoid.png";
import Lance from "./Lance.png";
import Maze from "./Maze.png";
import Mine from "./Mine.png";
import Monstrosity from "./Monstrosity.png";
import Ooze from "./Ooze.png";
import Path from "./Path.png";
import Pit from "./Pit.png";
import Priest from "./Priest.png";
import Prisoner from "./Prisoner.png";
import Ring from "./Ring.png";
import Ship from "./Ship.png";
import Staff from "./Staff.png";
import Stairway from "./Stairway.png";
import Statue from "./Statue.png";
import Tavern from "./Tavern.png";
import Temple from "./Temple.png";
import Tomb from "./Tomb.png";
import Tower from "./Tower.png";
import Tree from "./Tree.png";
import Warrior from "./Warrior.png";
import Well from "./Well.png";

export const DECK_OF_MANY_MORE_THINGS_URLS = [
  Beast, 
  Dragon,
  Elemental,
  Giant,
  Mage,
  Map,
  Plant,
  Shield,
  Undead,
  
  Aberration,
  Book,
  Bridge,
  Campfire,
  Cavern,
  Celestial,
  Construct,
  Corpse,
  Crossroads,
  Door,
  Expert,
  Fey,
  Fiend,
  Humanoid,
  Lance,
  Maze,
  Mine,
  Monstrosity,
  Ooze,
  Path,
  Pit,
  Priest,
  Prisoner,
  Ring,
  Ship,
  Staff,
  Stairway,
  Statue,
  Tavern,
  Temple,
  Tomb,
  Tower,
  Tree,
  Warrior,
  Well,
];
  